interface ReaderProgressBarProps {
  value: number;
  label?: string;
  tone?: 'primary' | 'accent';
  className?: string;
  inverse?: boolean;
  compact?: boolean;
}

export function ReaderProgressBar({
  value,
  label = 'Прогресс',
  tone = 'primary',
  className = '',
  inverse = false,
  compact = false,
}: ReaderProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, Math.round(value)));
  const trackClass = inverse ? 'bg-white/28' : 'bg-[rgba(26,26,26,0.08)]';
  const textClass = inverse ? 'text-white/82' : 'text-[rgba(26,26,26,0.42)]';
  const valueClass = inverse
    ? 'text-white'
    : tone === 'accent'
      ? 'text-[var(--accent)]'
      : 'text-[var(--primary)]';
  const fillClass = tone === 'accent' ? 'bg-[var(--accent)]' : 'bg-[var(--primary)]';

  return (
    <div className={className}>
      <div
        className={[
          'mb-1 flex items-center justify-between',
          compact ? 'text-[9px]' : 'text-[10px]',
        ].join(' ')}
      >
        <span className={['font-semibold uppercase tracking-[0.12em]', textClass].join(' ')}>
          {label}
        </span>
        <span className={['font-semibold', valueClass].join(' ')}>{clamped}%</span>
      </div>
      <div
        className={[
          'overflow-hidden rounded-full',
          compact ? 'h-1.5' : 'h-2',
          trackClass,
        ].join(' ')}
      >
        <div
          className={['h-full rounded-full transition-all', fillClass].join(' ')}
          style={{ width: `${clamped}%` }}
        />
      </div>
    </div>
  );
}
